import styled from 'styled-components';

export const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(100, 150, 200, 0.15);
  border-radius: 8px 8px 0 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 100;
  flex-wrap: nowrap;
  gap: 4px;
  overflow: visible;
  background: linear-gradient(90deg, rgba(25, 35, 55, 0.95) 0%, rgba(35, 50, 75, 0.9) 100%);
  
  /* Add subtle glass effect */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, 
      rgba(100, 150, 200, 0.05), 
      rgba(100, 150, 200, 0.15), 
      rgba(100, 150, 200, 0.05)
    );
    border-radius: 8px 8px 0 0;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(180deg, rgba(35, 50, 75, 0.6) 0%, rgba(30, 45, 70, 0.7) 100%);
  border-radius: 8px;
  padding: 6px 10px;
  margin-right: 8px;
  flex: 0 1 auto;
  min-width: 140px;
  max-width: 200px;
  border: 1px solid rgba(100, 150, 200, 0.15);
  transition: all 0.2s ease;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
  
  &:focus-within {
    border-color: rgba(80, 140, 220, 0.5);
    box-shadow: 0 0 0 2px rgba(80, 140, 220, 0.2), inset 0 1px 3px rgba(0, 0, 0, 0.15);
  }
`;

export const SearchInput = styled.input`
  background-color: transparent;
  border: none;
  color: white;
  font-size: 14px;
  width: 100%;
  outline: none;
  padding: 4px 0;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
    transition: color 0.2s;
  }
  
  &:focus::placeholder {
    color: rgba(255, 255, 255, 0.2);
  }
`;

export const SearchCountBadge = styled.span`
  color: rgba(180, 200, 230, 0.95);
  font-size: 12px;
  font-weight: 500;
  background: linear-gradient(135deg, rgba(60, 100, 160, 0.3) 0%, rgba(50, 90, 140, 0.4) 100%);
  border-radius: 20px;
  padding: 4px 10px;
  margin-right: 8px;
  border: 1px solid rgba(80, 140, 220, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
`;

export const ToolbarButton = styled.button`
  background: linear-gradient(135deg, rgba(45, 60, 85, 0.6) 0%, rgba(35, 50, 75, 0.7) 100%);
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  margin: 0 1px;
  height: 32px;
  min-width: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer !important;
  transition: all 0.2s ease;
  position: relative;
  user-select: none;
  border: 1px solid rgba(100, 150, 200, 0.15);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: linear-gradient(135deg, rgba(55, 75, 105, 0.7) 0%, rgba(45, 65, 95, 0.8) 100%);
    border-color: rgba(100, 150, 200, 0.25);
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    background: linear-gradient(135deg, rgba(50, 70, 95, 0.8) 0%, rgba(40, 60, 85, 0.85) 100%);
    transform: translateY(0px);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }
  
  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.4;
    background: rgba(30, 40, 60, 0.4);
    transform: none;
    box-shadow: none;
  }
  
  img {
    width: 14px;
    height: 14px;
    filter: invert(1);
    opacity: 0.9;
    transition: opacity 0.2s;
  }
  
  span {
    color: white;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.2px;
  }
  
  &:hover img {
    opacity: 1;
  }
  
  /* Override any global styles that might interfere with button functionality */
  pointer-events: auto !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  
  /* Add modern tooltip - positioned ABOVE the button */ 
  &::after {
    content: attr(title);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(20, 20, 20, 0.95);
    color: white;
    font-size: 11px;
    padding: 5px 10px;
    border-radius: 6px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
    pointer-events: none;
    z-index: 9999;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  &:hover::after {
    opacity: 0.95;
    visibility: visible;
    bottom: calc(100% + 10px);
  }
`;

export const NavigationButton = styled(ToolbarButton)`
  background: linear-gradient(135deg, rgba(50, 70, 100, 0.5) 0%, rgba(40, 60, 90, 0.6) 100%);
  border: 1px solid rgba(100, 150, 200, 0.25);
  padding: 6px 8px;
  
  &:hover {
    background: linear-gradient(135deg, rgba(60, 90, 130, 0.6) 0%, rgba(50, 80, 120, 0.7) 100%);
    border-color: rgba(100, 150, 200, 0.4);
  }
  
  &:active {
    background: linear-gradient(135deg, rgba(50, 70, 100, 0.7) 0%, rgba(40, 60, 90, 0.8) 100%);
    opacity: 0.9;
  }
  
  span {
    font-weight: 500;
    font-size: 11px;
    color: rgba(180, 200, 230, 0.95);
    text-shadow: none;
  }
`;

export const ToolbarDivider = styled.div`
  width: 1px;
  height: 20px;
  background: linear-gradient(to bottom, 
    rgba(100, 150, 200, 0.05), 
    rgba(100, 150, 200, 0.2), 
    rgba(100, 150, 200, 0.05)
  );
  margin: 0 4px;
  flex-shrink: 0;
`;

export const VideoCallButton = styled(ToolbarButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid rgba(59, 130, 246, 0.3);
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.1);
  transition: all 0.2s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 6px 8px;
  
  svg {
    width: 14px;
    height: 14px;
    color: rgba(255, 255, 255, 0.95);
    flex-shrink: 0;
  }
  
  &:hover {
    background: rgba(59, 130, 246, 0.25);
    border-color: rgba(59, 130, 246, 0.5);
    box-shadow: 0 4px 16px rgba(59, 130, 246, 0.2);
    transform: translateY(-1px);
  }
  
  &:active {
    background: rgba(59, 130, 246, 0.3);
    border-color: rgba(59, 130, 246, 0.6);
    transform: translateY(0px);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
  }
  
  span {
    font-weight: 600;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 0.2px;
    transition: all 0.2s ease;
  }
  
  &:hover span {
    color: rgba(255, 255, 255, 1);
  }
`;

export const PaymentButton = styled(ToolbarButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(16, 185, 129, 0.15);
  border: 1px solid rgba(16, 185, 129, 0.3);
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.1);
  transition: all 0.2s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 6px 8px;
  
  svg {
    width: 14px;
    height: 14px;
    color: rgba(255, 255, 255, 0.95);
    flex-shrink: 0;
  }
  
  &:hover {
    background: rgba(16, 185, 129, 0.25);
    border-color: rgba(16, 185, 129, 0.5);
    box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);
    transform: translateY(-1px);
  }
  
  &:active {
    background: rgba(16, 185, 129, 0.3);
    border-color: rgba(16, 185, 129, 0.6);
    transform: translateY(0px);
    box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);
  }
  
  span {
    font-weight: 600;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 0.2px;
    transition: all 0.2s ease;
  }
  
  &:hover span {
    color: rgba(255, 255, 255, 1);
  }
`;

export const WhiteboardButton = styled(ToolbarButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(168, 85, 247, 0.15);
  border: 1px solid rgba(168, 85, 247, 0.3);
  box-shadow: 0 2px 6px rgba(168, 85, 247, 0.1);
  transition: all 0.2s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 6px 8px;
  
  svg, img {
    width: 14px;
    height: 14px;
    color: rgba(255, 255, 255, 0.95);
    flex-shrink: 0;
  }
  
  img {
    filter: brightness(0) invert(1);
    opacity: 0.95;
  }
  
  &:hover {
    background: rgba(168, 85, 247, 0.25);
    border-color: rgba(168, 85, 247, 0.5);
    box-shadow: 0 4px 16px rgba(168, 85, 247, 0.2);
    transform: translateY(-1px);
  }
  
  &:active {
    background: rgba(168, 85, 247, 0.3);
    border-color: rgba(168, 85, 247, 0.6);
    transform: translateY(0px);
    box-shadow: 0 2px 8px rgba(168, 85, 247, 0.25);
  }
  
  span {
    font-weight: 600;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 0.2px;
    transition: all 0.2s ease;
  }
  
  &:hover span {
    color: rgba(255, 255, 255, 1);
  }
`;

export const SignatureButton = styled(ToolbarButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(236, 72, 153, 0.15);
  border: 1px solid rgba(236, 72, 153, 0.3);
  box-shadow: 0 2px 6px rgba(236, 72, 153, 0.1);
  transition: all 0.2s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 6px 8px;
  
  svg, img {
    width: 14px;
    height: 14px;
    color: rgba(255, 255, 255, 0.95);
    flex-shrink: 0;
  }
  
  img {
    filter: brightness(0) invert(1);
    opacity: 0.95;
  }
  
  &:hover {
    background: rgba(236, 72, 153, 0.25);
    border-color: rgba(236, 72, 153, 0.5);
    box-shadow: 0 4px 16px rgba(236, 72, 153, 0.2);
    transform: translateY(-1px);
  }
  
  &:active {
    background: rgba(236, 72, 153, 0.3);
    border-color: rgba(236, 72, 153, 0.6);
    transform: translateY(0px);
    box-shadow: 0 2px 8px rgba(236, 72, 153, 0.25);
  }
  
  span {
    font-weight: 600;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 0.2px;
    transition: all 0.2s ease;
  }
  
  &:hover span {
    color: rgba(255, 255, 255, 1);
  }
`;

// Service Questionnaire Dropdown Button
export const ServiceQuestionnaireButton = styled(ToolbarButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.15) 0%, rgba(234, 88, 12, 0.2) 100%);
  border: 1px solid rgba(251, 146, 60, 0.3);
  box-shadow: 0 2px 6px rgba(251, 146, 60, 0.1);
  transition: all 0.2s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: relative;
  padding: 6px 8px;
  
  /* Disable tooltip for this button since it has a dropdown */
  &::after {
    display: none !important;
  }
  
  svg, img {
    width: 14px;
    height: 14px;
    color: rgba(255, 255, 255, 0.95);
    flex-shrink: 0;
  }
  
  &:hover {
    background: linear-gradient(135deg, rgba(251, 146, 60, 0.25) 0%, rgba(234, 88, 12, 0.3) 100%);
    border-color: rgba(251, 146, 60, 0.5);
    box-shadow: 0 4px 16px rgba(251, 146, 60, 0.2);
    transform: translateY(-1px);
  }
  
  &:active {
    background: linear-gradient(135deg, rgba(251, 146, 60, 0.3) 0%, rgba(234, 88, 12, 0.35) 100%);
    border-color: rgba(251, 146, 60, 0.6);
    transform: translateY(0px);
    box-shadow: 0 2px 8px rgba(251, 146, 60, 0.25);
  }
  
  span {
    font-weight: 600;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.95);
    letter-spacing: 0.2px;
    transition: all 0.2s ease;
  }
  
  &:hover span {
    color: rgba(255, 255, 255, 1);
  }
`;

// Service Questionnaire Dropdown Menu
export const ServiceDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 220px;
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.98) 0%, rgba(15, 23, 42, 0.98) 100%);
  border: 1px solid rgba(100, 150, 200, 0.2);
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4), 0 2px 10px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: 99999;
  overflow: hidden;
  animation: dropdownSlide 0.2s ease-out;
  
  @keyframes dropdownSlide {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const ServiceDropdownItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(90deg, rgba(251, 146, 60, 0.15) 0%, transparent 100%);
  }
  
  &:not(:last-child) {
    border-bottom: 1px solid rgba(100, 150, 200, 0.1);
  }
  
  .icon {
    font-size: 18px;
    width: 24px;
    text-align: center;
  }
  
  .content {
    flex: 1;
  }
  
  .title {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.95);
    margin-bottom: 2px;
  }
  
  .description {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 400;
  }
`;

export default {
  ToolbarContainer,
  SearchContainer,
  SearchInput,
  SearchCountBadge,
  ToolbarButton,
  NavigationButton,
  ToolbarDivider,
  VideoCallButton,
  PaymentButton,
  WhiteboardButton,
  SignatureButton,
  ServiceQuestionnaireButton,
  ServiceDropdownMenu,
  ServiceDropdownItem
}; 